import React, { useCallback, useContext } from "react";
import { Button, Card, Divider, H5 } from "@blueprintjs/core";

import Splitter from "components/Splitter";
import ProjectMenu from "components/projects/ProjectMenu";

import { useState } from "react";
import ReactJson from "react-json-view";
import ResultsGrid from "components/projects/results/ResultsGrid";
import RunProjectDialog from "components/projects/RunProjectDialog";
import { useProjectHistory } from "hooks/useProjectHistory";
import { ProjectRun } from "types";
import { SelectedProjectContext, SettingsContext } from "utils/context";

export default function ResultsPage() {
    const [projectRun, setProjectRun] = useState<ProjectRun | undefined>();
    const [project] = useContext(SelectedProjectContext);
    const [settings] = useContext(SettingsContext);
    const [runDialogOpen, setRunDialogOpen] = useState(false);

    const toggle = useCallback(() => {
        setRunDialogOpen(!runDialogOpen);
    }, [runDialogOpen]);

    const [projectHistory, loading, error, refetch] = useProjectHistory(project?.projectId, settings.showRunning);
    return (
        <div className="main-container">
            <RunProjectDialog toggleRunForm={toggle} isOpen={runDialogOpen} />
            <ProjectMenu
                page="Runs"
                actions={[
                    <Button key="run" icon="play" text="Run Now" intent="primary" onClick={toggle} />,
                    <Divider key="divider" />,
                    <Button key="refresh" icon="refresh" text="Refresh" intent="primary" onClick={() => refetch()} />
                ]}
            />
            <div className="splitter-container">
                <Splitter
                    primaryFraction={50}
                    primary={
                        <div className="grid-container">
                            <div className="ag-theme-balham-dark ag">
                                <ResultsGrid
                                    setProjectRun={setProjectRun}
                                    projectHistory={projectHistory}
                                    loading={loading}
                                    error={error}
                                />
                            </div>
                        </div>
                    }
                    secondary={
                        <div className="secondary-card">
                            <Card className="json-viewer">
                                <H5 className="json-header">
                                    {projectRun ? projectRun.id : "Please Select a Run to View"}
                                </H5>

                                {projectRun && (
                                    <>
                                        <H5>Run Result: </H5>
                                        <ReactJson
                                            name="job"
                                            src={projectRun.results as object}
                                            style={{
                                                textAlign: "left",
                                                fontSize: "1rem",
                                                wordBreak: "break-all"
                                            }}
                                            displayDataTypes={false}
                                            displayObjectSize={false}
                                            // enableClipboard={false}
                                            theme="ashes"
                                            iconStyle="square"
                                        />
                                    </>
                                )}
                            </Card>
                        </div>
                    }
                ></Splitter>
            </div>
        </div>
    );
}
